module.exports = __webpack_public_path__ + "img/service_2.e6b2f706.png";